// @flow
import * as React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { gaReducer } from "../../GA";

import Gettext from "../../common/Gettext";
import { fontSize } from "../../common/styled-mixins";

const activeClassName = "navlink-active";

const Container = styled.div`
  background-color: #f6f6f6;

  @media (max-width: 959px) {
    display: none;
  }
`;

const Header = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: center;
  max-width: 1300px;
  height: 46px;
  margin: 0 auto;
  padding: 0 5px;
  z-index: 9;
`;

const Link = styled(NavLink).attrs({
  activeClassName
})`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;
  padding: 0 20px;
  font-size: ${fontSize(14, 20)};
  line-height: 1;
  text-align: center;
  text-decoration: none;
  color: ${props => props.theme.indexMajor};
  cursor: pointer;

  @media (min-width: 960px) {
    :hover {
      color: #4e2a81;
      background-color: #e7e7e7;
      box-shadow: inset 0px -4px 0px 0px ${props => props.theme.accent};
    }
  }

  &.${activeClassName} {
    font-weight: bold;
    background-color: ${props => props.theme.accent};
  }
`;

export const HelpdeskHeader = (props: {}) => (
  <Container>
    <Header>
      <Link to="/helpdesk" exact>
        <Gettext>Help Center</Gettext>
      </Link>
      <Link
        to="/sightseeing"
        onClick={() => gaReducer("ACTIVATE_TOUR_FROM_HELPDESK")}
      >
        <Gettext>Start Welcome Tour</Gettext>
      </Link>
      <Link to="/helpdesk/faq">
        <Gettext>FAQ</Gettext>
      </Link>
      <Link to="/helpdesk/start">
        <Gettext>Start</Gettext>
      </Link>
      <Link to="/helpdesk/practicing">
        <Gettext>Practicing</Gettext>
      </Link>
      <Link to="/helpdesk/skilled">
        <Gettext>Skilled</Gettext>
      </Link>
      <Link to="/helpdesk/knowledge_base">
        <Gettext>Knowledge base</Gettext>
      </Link>
      <Link to="/helpdesk/video">
        <Gettext>Video</Gettext>
      </Link>
      <Link to="/helpdesk/safety">
        <Gettext>Safety</Gettext>
      </Link>
      {props.showContactUs && <Link to="/helpdesk/contacts">
        <Gettext>Contact us</Gettext>
      </Link>}
    </Header>
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/Helpdesk/Header/Header.js